import Vue from "vue";
import {APIHOST} from "@/settings/server";
import $store from "@/store";
import axios from "axios";

class PrintPackageService {
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }

    createPrintPackage({region, area, client, mails}) {
        return Vue.axios.post(`${APIHOST}/api/PrintPackage`, {
                Client: client ? client.id : null,
                Region: region ? region.id : null,
                Area: area ? area.id : null,
                UIds: mails
            },
            {
                headers: {
                    'Authorization': `Bearer ${$store.getters.accessToken}`
                }
            })
    }

    get(uid) {
        return Vue.axios.get(`${APIHOST}/api/PrintPackage`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: uid
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    getMails(uid) {
        return Vue.axios.get(`${APIHOST}/api/PrintPackageMail`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: uid
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    getDatatable({skip, limit, sort, desc, region, area, client, start, end}) {
        return Vue.axios.get(`${APIHOST}/api/PrintPackageDataTable`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                limit: limit,
                skip: skip,
                sort: sort,
                desc: desc,
                client: client ? client.id : null,
                region: region ? region.id : null,
                area: area ? area.id : null,
                start: start ? start.format('YYYY-MM-DD') : null,
                end: end ? end.format('YYYY-MM-DD') : null
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    getPdfPath(printPackage) {
        return `${APIHOST}/api/PrintPackagePdf/${printPackage.uid}`
    }

    getPdf(printPackage) {
        return Vue.axios.get(`${APIHOST}/api/PrintPackagePdf`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: printPackage.uid
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }
}

export default new PrintPackageService()
